import { useSelector } from 'react-redux';

import { selectHasWirelessInternet, selectUser, selectUserInfo } from '@app/redux';
import { Issuer, selectConfig } from '@app/redux/config';

import { ProductInstanceStatus } from '@mfe/shared/schema-types';

import { useCanPlaceOrders } from './useCanPlaceOrders';
import { useHasPlanChangePending } from './useHasPlanChangePending';

export const useCanChangePlan = () => {
  const { isSuspended, isDisconnected } = useCanPlaceOrders();
  const { hasPlanChangePending } = useHasPlanChangePending();
  const hasWirelessInternet = useSelector(selectHasWirelessInternet);

  const {
    userInfo: { isPreInstall },
  } = useSelector(selectUserInfo);

  const {
    user: { productInstanceStatus },
  } = useSelector(selectUser);

  const { issuer } = useSelector(selectConfig);
  const isSalesforce = issuer === Issuer.Salesforce;

  if (
    hasWirelessInternet ||
    productInstanceStatus === ProductInstanceStatus.Error ||
    isPreInstall ||
    isSuspended ||
    isDisconnected
  ) {
    return false;
  }

  return !(hasPlanChangePending || isSalesforce);
};
